export { View as Rate } from './view'
